import { patternEmailWithCyrillic } from "./helpers";

export const required = (msg) => (v) => !!v || msg;
export const notRequired = (v) => !v;
export const phone = (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона";
export const min = (count) => (v) => v.length >= count || `Минимум ${count} символов`;
export const notRussian = (v) => !/[А-Я]|[а-я]|\s/.test(v) || "Без пробелов и букв русского алфавита";
export const upper = (v) => /[A-Z]/.test(v) || "Одна заглавная латинская буква";
export const lower = (v) => /[a-z]/.test(v) || "Одна строчная латинская буква";
export const digit = (v) => /\d/.test(v) || "Одна цифра";
export const same = (sameValue, msg) => (v) => v === sameValue || msg;
export const email = (v) => patternEmailWithCyrillic.test(v) || "Введите корректный e-mail";
// inn: v => (!!v && !!validateInn(v)) || "Введите корректный ИНН",
// ogrn: v => (!!v && !!validateOgrn(v)) || "Введите корректный " + this.ogrnLabel,
// snils: v => !v || validateSnils(v) || "Введите корректный СНИЛС"
